module.exports = __webpack_public_path__ + "static/media/shell32_167.14be2b38.ico";